<template>
    <div class="row">
        <div class="col-12">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <div class="card custom-card card-body bg-warning tx-white">
                        <h6>فیلتر دسته بندی ها</h6>
                        <hr class="mb-4 mt-2" />
                        <label class="ckbox"
                            ><input
                                type="checkbox"
                                value="all"
                                id="select-all"
                                checked
                                @change="selectAll"
                            /><span>انتخاب همه</span></label
                        >
                        <label
                            class="ckbox mt-3"
                            v-for="(category, index) in categories"
                            :key="index"
                            ><input
                                type="checkbox"
                                checked
                                @change="changeCategories(category.categoryId)"
                                :value="category.categoryId"
                                :id="'category-' + category.categoryId"
                            /><span>{{ category.title }}</span></label
                        >
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="row" v-if="!themeId && allCards.length && fetchedData">
                        <div
                            class="col-md-3 card-container"
                            v-for="(card, index) in cards"
                            :key="index"
                        >
                            <img
                                :src="'https://cardapi.sabinarya.com' + card.address"
                                :alt="card.title"
                            />
                            <h5>{{ card.title }}</h5>
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <button
                                        @click="add(card.themeId, card.title, card.address)"
                                        class="btn ripple btn-success btn-icon btn-block"
                                    >
                                        <i class="fe fe-check"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else-if="!allCards.length && !fetchedData">
                        <div class="col-md-3 card-container" v-for="index in 8" :key="index">
                            <span class="image-placeholder animate"></span>
                            <h5 class="title-placeholder animate"></h5>
                            <div class="row justify-content-center">
                                <div class="col-md-4">
                                    <button
                                        class="btn ripple btn-placeholder btn-icon animate btn-add-to-card"
                                    ></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else-if="themeId">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>انتخاب فایل پرسنل</label>
                                <div class="input-group file-browser">
                                    <input
                                        type="text"
                                        class="form-control border-left-0 browse-file"
                                        id="input-pan"
                                        placeholder="آپلود فایل"
                                        readonly=""
                                    />
                                    <label class="input-group-btn mb-0">
                                        <span class="btn btn-primary">
                                            انتخاب کنید
                                            <input
                                                type="file"
                                                style="display: none;"
                                                accept=".xlsx"
                                                @input="setExcelFile"
                                            />
                                        </span>
                                    </label>
                                </div>
                                <p class="mt-3 mb-0">
                                    <a href="#" @click="(e) => getExcelSample(e)"
                                        >دریافت فایل نمونه</a
                                    >
                                </p>
                            </div>
                        </div>
                        <div
                            class="col-md-2"
                            v-if="
                                $store.state.role == 'branches' ||
                                    $store.state.role == 'izbank-admin'
                            "
                        >
                            <div class="form-group">
                                <label>شارژ دارد ؟</label>
                                <select class="form-control" v-model="hasCharge">
                                    <option value="0">خیر</option>
                                    <option value="1">بله</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3" v-if="hasCharge == 1">
                            <div class="form-group">
                                <label>شناسه پرداخت / شماره پیگیری</label>
                                <input
                                    type="tel"
                                    class="form-control ltr-input"
                                    v-model="paymentIdentifier"
                                    maxlength="30"
                                />
                            </div>
                        </div>
                        <div class="col-md-3" v-if="hasCharge == 1">
                            <div class="form-group">
                                <label>شماره ارجاع / شماره درخواست</label>
                                <input
                                    type="tel"
                                    :class="
                                        `form-control ltr-input ${
                                            rrn.length != 12 ? 'is-invalid' : ''
                                        }`
                                    "
                                    v-model="rrn"
                                    maxlength="12"
                                />
                            </div>
                        </div>
                        <div class="col-md-4" v-if="$store.state.role == 'admin'">
                            <div class="form-group">
                                <label>میزان تخفیف</label>
                                <input
                                    type="tel"
                                    class="form-control ltr-input"
                                    @keyup="(e) => changeCustomDepositValue(e)"
                                    v-model="discount"
                                />
                            </div>
                        </div>
                        <div class="col-md-12 mt-2">
                            <button
                                class="btn btn-success"
                                v-if="file"
                                @click="submit"
                                :disabled="
                                    totalCharge > 0 &&
                                        (!rrn || rrn.length != 12 || !paymentIdentifier)
                                "
                            >
                                ثبت درخواست
                            </button>
                            <button
                                class="btn btn-primary mr-2"
                                v-if="resultFile"
                                @click="getResultExcelFile"
                            >
                                دریافت فایل نتیجه
                            </button>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-12">
                            <div class="alert alert-info mb-0">
                                <p class="mb-0">طرحی یافت نشد</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FizicalCard",
    props: ["addToCard", "customerId"],
    data() {
        return {
            allCards: [],
            cards: [],
            categories: [],
            selectedCategories: [],
            fetchedData: false,
            cartCards: [],
            cardType: 1,
            themeId: "",
            title: "",
            image: "",
            file: "",
            discount: 0,
            resultFile: "",
            totalCharge: 0,
            paymentIdentifier: "",
            rrn: "",
            hasCharge: 0,
            showLoading: false
        };
    },
    methods: {
        getData() {
            this.$api.post("Cards/AvailableThemes/bon", { type: 1 }).then(({ data }) => {
                setTimeout(() => {
                    this.allCards = data.result;
                    this.cards = data.result;
                    this.fetchedData = true;
                }, 1000);
            });
            this.$api.get("Cards/Categories").then(({ data }) => {
                this.categories = data.result;
                this.categories.map((category) => {
                    this.selectedCategories.push(category.categoryId);
                });
            });
        },
        add(themeId, title, image) {
            this.themeId = themeId;
            this.title = title;
            this.image = image;
        },
        addOrder() {
            this.addToCard(this.themeId, this.title, this.cardType, this.image, this.file);
        },
        setFilterType(element, type) {
            let filterTypes = document.getElementsByClassName("filter-item");
            for (let i = 0; i < filterTypes.length; i++) {
                if (typeof filterTypes[i] == "object") filterTypes[i].classList.remove("active");
            }
            element.target.classList.add("active");
        },
        changeCategories(id) {
            this.cards = [];
            if (this.selectedCategories.includes(id))
                this.selectedCategories.splice(this.selectedCategories.indexOf(id), 1);
            else this.selectedCategories.push(id);
            this.selectedCategories.map((categoryId) => {
                this.allCards.map((card) => {
                    if (card.categories.includes(categoryId)) this.cards.push(card);
                });
            });
        },
        async toBase64(file) {
            this.totalCharge = 0;
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    // const fileData = atob(reader.result.split('base64,')[1]);
                    // const fileArray = fileData.replace(/\n/g,'').split('\r');
                    // fileArray.shift();
                    // let charge = 0;
                    // fileArray.map(row => {
                    //     charge = row.split(',')[1]
                    //     if(charge)
                    //         this.totalCharge = this.totalCharge + parseInt(charge);
                    //     charge = 0;
                    // })
                    resolve(reader.result);
                };
                reader.onerror = (error) => reject(error);
            });
        },
        async setExcelFile(e) {
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById("input-pan").setAttribute("placeholder", file.name);
        },
        selectAll(e) {
            this.selectedCategories = [];
            this.cards = [];
            if (e.target.checked)
                this.categories.map((category) => {
                    this.selectedCategories.push(category.categoryId);
                    document.getElementById("category-" + category.categoryId).checked = true;
                });
            else
                this.categories.map((category) => {
                    document.getElementById("category-" + category.categoryId).checked = false;
                });
            this.selectedCategories.map((categoryId) => {
                this.allCards.map((card) => {
                    if (card.categories.includes(categoryId)) this.cards.push(card);
                });
            });
        },
        getExcelSample(e) {
            e.preventDefault();
            this.$api.get("Organizations/Bonus/Order/Sample").then(({ data }) => {
                let a = window.document.createElement("a");
                a.setAttribute(
                    "href",
                    "https://cardapi.sabinarya.com/api/v1/Lookup/download/" + data.result
                );
                let fileName = data.result;
                a.setAttribute("download", fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        getResultExcelFile() {
            let a = window.document.createElement("a");
            a.setAttribute(
                "href",
                "https://cardapi.sabinarya.com/api/v1/Lookup/download/" + this.resultFile
            );
            let fileName = this.resultFile;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        submit() {
            this.showLoading = true;
            const postedData = {
                domainDataId: this.customerId,
                file: this.file,
                themeId: this.themeId,
                rrn: this.rrn,
                paymentId: this.paymentIdentifier,
                title: "",
                base64Receipt: "",
                discount: parseInt(this.discount.toString().replace(/,/g, ""))
            };
            this.$api
                .post("Organizations/Bonus/Order", postedData)
                .then(({ data }) => {
                    this.resultFile = data.result ? data.result.fileString : "";
                    if (data.status)
                        this.$swal({
                            icon: "success",
                            title: "تبریک !",
                            text: "ثبت درخواست بن کارت با موفقیت انجام شد"
                        }).then((res) => {
                            if (res.isConfirmed) {
                                this.$router.push({ path: "/?today=true" });
                            }
                        });
                })
                .finally(() => {
                    this.showLoading = false;
                });
        }
    },
    created() {
        this.getData();
    }
};
</script>
